import { Injectable } from "@angular/core";

import { take } from "rxjs/operators";
import { ProductService } from "../../api_services/product.service";

@Injectable({
  providedIn: "root",
})
export class ProductresolverService {
  constructor(private productService: ProductService) {}

  resolve() {
    return this.productService.getProducts().pipe(take(1));
  }
}
